module.exports = __webpack_public_path__ + "img/KMS-M-13.df763521.svg";